import { createAsyncThunk } from '@reduxjs/toolkit';
export const LoadLimits = createAsyncThunk(
    'currentUser/loadLimits',
    async (_, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const response = await axios.get(`api/limits`);
        return response;
    }
);